import { render, staticRenderFns } from "./FullPageWidget.vue?vue&type=template&id=f496a25a&scoped=true&"
import script from "./FullPageWidget.vue?vue&type=script&lang=js&"
export * from "./FullPageWidget.vue?vue&type=script&lang=js&"
import style0 from "./FullPageWidget.vue?vue&type=style&index=0&id=f496a25a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f496a25a",
  null
  
)

export default component.exports